import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M19 20a1 1 0 1 1-2 0m2 0a1 1 0 1 0-2 0m2 0h-2m14 0a1 1 0 1 1-2 0m2 0a1 1 0 1 0-2 0m2 0h-2m3 12a9.985 9.985 0 0 0-8-4 9.985 9.985 0 0 0-8.001 4M24 44v0c11.046 0 20-8.954 20-20v0c0-11.046-8.954-20-20-20v0C12.954 4 4 12.954 4 24v0c0 11.046 8.954 20 20 20Z"
    />
  </svg>
)
export default SvgComponent
